// extracted by mini-css-extract-plugin
export default {"favorite":"styles_favorite__IY8Lh","favorite__colored":"styles_favorite__colored__PnLcx","favorite__loginMessage":"styles_favorite__loginMessage__nl8T9"};